<template>
  <layout-basic>
    <section class="billing-result">
      <v-container>
        <v-card class="result-card" flat>
          <div class="result-icon result-icon--cancel" aria-hidden="true">!</div>
          <p class="result-eyebrow">CHECKOUT CANCELLED</p>
          <h1>Payment not completed</h1>
          <p class="result-lead">
            You left Stripe checkout before payment was finished. No charge was
            made. You can return to the plan picker and try again whenever you
            are ready.
          </p>
          <p v-if="sessionId" class="result-session">
            Reference: {{ sessionId }}
          </p>
          <div class="result-actions">
            <v-btn class="result-primary" depressed large to="/billing">
              Back to plans
            </v-btn>
            <v-btn
              outlined
              large
              color="#002458"
              href="mailto:help@improve.online"
            >
              Contact support
            </v-btn>
          </div>
        </v-card>
      </v-container>
    </section>
  </layout-basic>
</template>

<script>
import LayoutBasic from "@/layouts/Dashboard";

export default {
  name: "BillingCancel",
  components: { LayoutBasic },
  data() {
    return {
      sessionId: ""
    };
  },
  created() {
    this.sessionId = this.$route.query.session_id || "";
  }
};
</script>

<style scoped>
.billing-result {
  --navy: #002458;
  --teal: #08a0a8;
  --grey: #6b7280;
  background: #f7f9fb;
  padding: 48px 0 80px;
}

.result-card {
  max-width: 640px;
  margin: 0 auto;
  text-align: center;
  border: 1px solid #e6ebf1;
  border-radius: 14px;
  padding: 40px 32px 36px;
  box-shadow: 0 12px 40px rgba(0, 36, 88, 0.06);
}

.result-icon {
  width: 56px;
  height: 56px;
  border-radius: 50%;
  margin: 0 auto 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 22px;
  font-weight: 700;
}

.result-icon--cancel {
  background: #fff3cd;
  color: #002458;
}

.result-eyebrow {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.18em;
  color: var(--teal);
  margin: 0 0 10px;
}

.result-card h1 {
  font-size: 32px;
  font-weight: 700;
  color: var(--navy);
  margin: 0 0 12px;
}

.result-lead {
  font-size: 16px;
  line-height: 1.5;
  color: var(--grey);
  margin: 0 0 12px;
}

.result-session {
  font-size: 12px;
  color: #9aa4b2;
  word-break: break-all;
  margin: 0 0 8px;
}

.result-actions {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 24px;
}

.result-primary {
  background-color: #002458 !important;
  color: #ffffff !important;
  text-transform: none !important;
  font-weight: 700 !important;
}
</style>
